import { MAX_IDENTIFIER_LENGTH, MAX_NOTIFICATION_BODY_LENGTH, MAX_NOTIFICATION_TITLE_LENGTH, MAX_NOTIFICATION_TYPE_LENGTH, MAX_PATH_LENGTH, MAX_TIMESTAMP_LENGTH, } from "./constants.js";
import { isRecord, readSafeRelativePath, readSeq, readText } from "./primitives.js";
function readNotificationTime(value) {
    const text = readText(value, MAX_TIMESTAMP_LENGTH);
    if (text === null) {
        return null;
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|([+-])(\d{2}):(\d{2}))?$/.exec(text);
    if (!match) {
        return null;
    }
    const [, year, month, day, hour, minute, second, , offsetHour, offsetMinute] = match;
    const y = Number(year);
    const m = Number(month);
    const d = Number(day);
    const leapYear = y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
    const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1];
    return daysInMonth !== undefined && d > 0 && d <= daysInMonth &&
        Number(hour) < 24 && Number(minute) < 60 && Number(second) < 60 &&
        (offsetHour === undefined || (Number(offsetHour) < 24 && Number(offsetMinute) < 60)) &&
        Number.isFinite(Date.parse(text))
        ? text
        : null;
}
function readNotificationPath(value) {
    const path = readSafeRelativePath(value, MAX_PATH_LENGTH);
    // 仅提供单工单详情深链，不接受其他页面、query、hash 或路径归一化后的变体。
    if (path === null || path !== value || !/^\/embedded\/tickets\/[A-Za-z0-9._~!$&'()*+,;=:@%-]+$/.test(path)) {
        return null;
    }
    const id = decodeURIComponent(path.slice("/embedded/tickets/".length));
    return /[\x00-\x20\x7f/\\?#]/.test(id) ? null : path;
}
/** 严格校验通知快照，丢弃未知字段；非法数据返回 null。 */
export function parseEmbeddedNotification(value) {
    if (!isRecord(value)) {
        return null;
    }
    const cursor = readSeq(value.cursor);
    const notificationId = readText(value.notificationId, MAX_IDENTIFIER_LENGTH);
    const type = readText(value.type, MAX_NOTIFICATION_TYPE_LENGTH);
    const { severity, title, body } = value;
    const creationTime = readNotificationTime(value.creationTime);
    const path = value.path === null ? null : readNotificationPath(value.path);
    if (cursor === null || notificationId === null || type === null ||
        (severity !== 0 && severity !== 1 && severity !== 2) ||
        typeof title !== "string" || title.length > MAX_NOTIFICATION_TITLE_LENGTH ||
        typeof body !== "string" || body.length > MAX_NOTIFICATION_BODY_LENGTH ||
        creationTime === null || (value.path !== null && path === null)) {
        return null;
    }
    return { cursor, notificationId, type, severity, title, body, creationTime, path };
}
//# sourceMappingURL=notification.js.map